// components/ui/Pagination.jsx
// ============================================================================
// COMPOSANT PAGINATION RÉUTILISABLE
// ============================================================================

import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const Pagination = ({ page, totalPages, total, limit, onPageChange, itemLabel = 'employé' }) => {
  if (totalPages <= 1) return null;

  const debut = (page - 1) * limit + 1;
  const fin = Math.min(page * limit, total);

  // Calculer les pages à afficher (max 5 boutons)
  const getPages = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (page <= 3) {
        pages.push(1, 2, 3, 4, '...', totalPages);
      } else if (page >= totalPages - 2) {
        pages.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, '...', page - 1, page, page + 1, '...', totalPages);
      }
    }
    return pages;
  };

  return (
    <div className="flex items-center justify-between px-4 py-3 border-t border-gray-100 bg-gray-50/50">
      {/* Info */}
      <span className="text-xs font-medium text-gray-500">
        {debut}–{fin} sur <strong className="text-gray-700">{total}</strong> {itemLabel}{total > 1 ? 's' : ''}
      </span>

      {/* Boutons */}
      <div className="flex items-center gap-1">
        {/* Précédent */}
        <button
          onClick={() => onPageChange(page - 1)}
          disabled={page === 1}
          className="p-1.5 rounded-lg border border-gray-200 bg-white text-gray-600 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-all"
        >
          <ChevronLeft size={14} />
        </button>

        {/* Numéros */}
        {getPages().map((p, i) =>
          p === '...' ? (
            <span key={`ellipsis-${i}`} className="px-2 text-xs text-gray-400 font-medium">...</span>
          ) : (
            <button
              key={p}
              onClick={() => onPageChange(p)}
              className="w-8 h-8 rounded-lg text-xs font-bold transition-all border"
              style={
                p === page
                  ? { backgroundColor: '#448696', color: 'white', borderColor: '#448696' }
                  : { backgroundColor: 'white', color: '#4a5568', borderColor: '#e2e8f0' }
              }
            >
              {p}
            </button>
          )
        )}

        {/* Suivant */}
        <button
          onClick={() => onPageChange(page + 1)}
          disabled={page === totalPages}
          className="p-1.5 rounded-lg border border-gray-200 bg-white text-gray-600 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-all"
        >
          <ChevronRight size={14} />
        </button>
      </div>
    </div>
  );
};

export default Pagination;